import { render, staticRenderFns } from "./SwipeC.vue?vue&type=template&id=0ef70774&"
import script from "./SwipeC.vue?vue&type=script&lang=js&"
export * from "./SwipeC.vue?vue&type=script&lang=js&"
import style0 from "./SwipeC.vue?vue&type=style&index=0&id=0ef70774&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports